// interface
import { IPaginationList } from './PaginationList.interface';
// rsuite
import { Pagination, SelectPicker } from 'rsuite';
// style
import style from './PaginationList.module.css';

const PaginationList = ({
    total,
    activePage,
    onChangePage,
    onChangeLimit,
    limit,
    pages,
    isLoading,
}: IPaginationList) => {
    const limitOptions = [
        {
            value: 20,
            label: 20,
        },
        {
            value: 50,
            label: 50,
        },
        {
            value: 100,
            label: 100,
        },
    ];

    return (
        <div className={style['container-pagination']}>
            {isLoading ? (
                <div className={style['wrapper-pagination']}>
                    <Pagination
                        className={style['pagination']}
                        size="sm"
                        prev={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M10.8 12.0008L14.7 15.9008C14.8834 16.0841 14.975 16.3174 14.975 16.6008C14.975 16.8841 14.8834 17.1174 14.7 17.3008C14.5167 17.4841 14.2834 17.5758 14 17.5758C13.7167 17.5758 13.4834 17.4841 13.3 17.3008L8.70005 12.7008C8.60005 12.6008 8.52922 12.4924 8.48755 12.3758C8.44588 12.2591 8.42505 12.1341 8.42505 12.0008C8.42505 11.8674 8.44588 11.7424 8.48755 11.6258C8.52922 11.5091 8.60005 11.4008 8.70005 11.3008L13.3 6.70078C13.4834 6.51745 13.7167 6.42578 14 6.42578C14.2834 6.42578 14.5167 6.51745 14.7 6.70078C14.8834 6.88411 14.975 7.11745 14.975 7.40078C14.975 7.68411 14.8834 7.91745 14.7 8.10078L10.8 12.0008Z"
                                    fill="#ACAEC4"
                                />
                            </svg>
                        }
                        next={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M12.6 12.0008L8.70005 8.10078C8.51672 7.91745 8.42505 7.68411 8.42505 7.40078C8.42505 7.11745 8.51672 6.88411 8.70005 6.70078C8.88338 6.51745 9.11672 6.42578 9.40005 6.42578C9.68338 6.42578 9.91672 6.51745 10.1 6.70078L14.7 11.3008C14.8 11.4008 14.8709 11.5091 14.9125 11.6258C14.9542 11.7424 14.975 11.8674 14.975 12.0008C14.975 12.1341 14.9542 12.2591 14.9125 12.3758C14.8709 12.4924 14.8 12.6008 14.7 12.7008L10.1 17.3008C9.91672 17.4841 9.68338 17.5758 9.40005 17.5758C9.11672 17.5758 8.88338 17.4841 8.70005 17.3008C8.51672 17.1174 8.42505 16.8841 8.42505 16.6008C8.42505 16.3174 8.51672 16.0841 8.70005 15.9008L12.6 12.0008Z"
                                    fill="#0171E6"
                                />
                            </svg>
                        }
                        ellipsis={true}
                        total={total}
                        activePage={activePage}
                        boundaryLinks={true}
                        maxButtons={5}
                        limit={limit}
                        limitOptions={[20, 50, 100]}
                        layout={['pager']}
                        onChangeLimit={onChangeLimit}
                        onChangePage={onChangePage}
                        pages={pages}
                        disabled={isLoading}
                    />
                    <SelectPicker //@ts-ignore
                        caretAs={() => (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M12 14.9504C11.8667 14.9504 11.7417 14.9296 11.625 14.8879C11.5084 14.8462 11.4 14.7754 11.3 14.6754L6.70005 10.0754C6.51672 9.89206 6.42505 9.65872 6.42505 9.37539C6.42505 9.09206 6.51672 8.85872 6.70005 8.67539C6.88338 8.49206 7.11672 8.40039 7.40005 8.40039C7.68338 8.40039 7.91672 8.49206 8.10005 8.67539L12 12.5754L15.9 8.67539C16.0834 8.49206 16.3167 8.40039 16.6 8.40039C16.8834 8.40039 17.1167 8.49206 17.3 8.67539C17.4834 8.85872 17.575 9.09206 17.575 9.37539C17.575 9.65872 17.4834 9.89206 17.3 10.0754L12.7 14.6754C12.6 14.7754 12.4917 14.8462 12.375 14.8879C12.2584 14.9296 12.1334 14.9504 12 14.9504Z"
                                    fill="#6B6F93"
                                />
                            </svg>
                        )}
                        searchable={false}
                        data={limitOptions}
                        placement="topStart"
                        menuClassName="menu"
                        className={style['select-picker-container']}
                        cleanable={false}
                        defaultValue={50}
                        onChange={onChangeLimit}
                        disabled={isLoading}
                    />
                </div>
            ) : (
                <div className={style['wrapper-pagination']}>
                    <Pagination
                        className={style['pagination']}
                        size="sm"
                        prev={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M10.8 12.0008L14.7 15.9008C14.8834 16.0841 14.975 16.3174 14.975 16.6008C14.975 16.8841 14.8834 17.1174 14.7 17.3008C14.5167 17.4841 14.2834 17.5758 14 17.5758C13.7167 17.5758 13.4834 17.4841 13.3 17.3008L8.70005 12.7008C8.60005 12.6008 8.52922 12.4924 8.48755 12.3758C8.44588 12.2591 8.42505 12.1341 8.42505 12.0008C8.42505 11.8674 8.44588 11.7424 8.48755 11.6258C8.52922 11.5091 8.60005 11.4008 8.70005 11.3008L13.3 6.70078C13.4834 6.51745 13.7167 6.42578 14 6.42578C14.2834 6.42578 14.5167 6.51745 14.7 6.70078C14.8834 6.88411 14.975 7.11745 14.975 7.40078C14.975 7.68411 14.8834 7.91745 14.7 8.10078L10.8 12.0008Z"
                                    fill="#ACAEC4"
                                />
                            </svg>
                        }
                        next={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M12.6 12.0008L8.70005 8.10078C8.51672 7.91745 8.42505 7.68411 8.42505 7.40078C8.42505 7.11745 8.51672 6.88411 8.70005 6.70078C8.88338 6.51745 9.11672 6.42578 9.40005 6.42578C9.68338 6.42578 9.91672 6.51745 10.1 6.70078L14.7 11.3008C14.8 11.4008 14.8709 11.5091 14.9125 11.6258C14.9542 11.7424 14.975 11.8674 14.975 12.0008C14.975 12.1341 14.9542 12.2591 14.9125 12.3758C14.8709 12.4924 14.8 12.6008 14.7 12.7008L10.1 17.3008C9.91672 17.4841 9.68338 17.5758 9.40005 17.5758C9.11672 17.5758 8.88338 17.4841 8.70005 17.3008C8.51672 17.1174 8.42505 16.8841 8.42505 16.6008C8.42505 16.3174 8.51672 16.0841 8.70005 15.9008L12.6 12.0008Z"
                                    fill="#0171E6"
                                />
                            </svg>
                        }
                        ellipsis={true}
                        total={total}
                        activePage={activePage}
                        boundaryLinks={true}
                        maxButtons={5}
                        limit={limit}
                        limitOptions={[20, 50, 100]}
                        layout={['pager']}
                        onChangeLimit={onChangeLimit}
                        onChangePage={onChangePage}
                        pages={pages}
                    />
                    <SelectPicker //@ts-ignore
                        caretAs={() => (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M12 14.9504C11.8667 14.9504 11.7417 14.9296 11.625 14.8879C11.5084 14.8462 11.4 14.7754 11.3 14.6754L6.70005 10.0754C6.51672 9.89206 6.42505 9.65872 6.42505 9.37539C6.42505 9.09206 6.51672 8.85872 6.70005 8.67539C6.88338 8.49206 7.11672 8.40039 7.40005 8.40039C7.68338 8.40039 7.91672 8.49206 8.10005 8.67539L12 12.5754L15.9 8.67539C16.0834 8.49206 16.3167 8.40039 16.6 8.40039C16.8834 8.40039 17.1167 8.49206 17.3 8.67539C17.4834 8.85872 17.575 9.09206 17.575 9.37539C17.575 9.65872 17.4834 9.89206 17.3 10.0754L12.7 14.6754C12.6 14.7754 12.4917 14.8462 12.375 14.8879C12.2584 14.9296 12.1334 14.9504 12 14.9504Z"
                                    fill="#6B6F93"
                                />
                            </svg>
                        )}
                        searchable={false}
                        data={limitOptions}
                        placement="topStart"
                        menuClassName="menu"
                        className={style['select-picker-container']}
                        cleanable={false}
                        defaultValue={limit}
                        onChange={onChangeLimit}
                    />
                </div>
            )}
        </div>
    );
};

export default PaginationList;
